import { $tenant } from '@msdk/common'
import { ApplicationHeaderWrapper } from '@msdk/ui'
import { styled } from '@msdk/ui'
import { ClinicMenu } from 'components/ClinicMenu'
import { SettingsMenu } from 'components/SettingsMenu'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

import { NotificationIcon } from './NotificationIcon'

const UserInfo = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  color: white;
`

export function Header() {
  const navigate = useNavigate()
  const tenant = useRecoilValue($tenant)

  const onLogoClick = () => {
    navigate('/' + tenant)
  }

  return (
    <>
      <ApplicationHeaderWrapper onLogoClick={onLogoClick}>
        <UserInfo data-test-id="SHELL-HEADER-USERINFO">
          <ClinicMenu />
          <NotificationIcon />
          <SettingsMenu />
        </UserInfo>
      </ApplicationHeaderWrapper>
    </>
  )
}
